import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { enTranslations } from "./translations/en"
import { fiTranslations } from "./translations/fi"
import { logger } from "./utils/add/logger/logger"

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      fi: { translation: fiTranslations }
    },
    fallbackLng: "en",
    // Uncomment to use Finnish
    //lng: "fi",
    //debug: true,
    interpolation: {
      escapeValue: false
    }
  })
  .catch((error: unknown) => {
    logger.error("i18n initialization error", error)
  })
